import Modal from '@/common/components/Modal'
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react'
import useIncreaseTefTableVersion from '../../hooks/useIncreaseTefTableVersion';
import Button from '@/common/components/Button';
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple';

interface IncreaseTefTableVersionProps {
  matrixBranchId: string
  establishmentCompanyId: string
}

export default function IncreaseTefTableVersion({ matrixBranchId, establishmentCompanyId }: IncreaseTefTableVersionProps) {
  const queryClient = useQueryClient();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const { mutate: confirmFiscalDocument } = useIncreaseTefTableVersion({
    id: matrixBranchId,
    onSuccess: (res) => {
      setModalIsOpen(false);
      setIsError(false);
      setMessages([`Versão atualizada com sucesso para ${res.data.data?.table_version}!`]);
      queryClient.invalidateQueries({queryKey: ["establishmentCompany", establishmentCompanyId]})
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setModalIsOpen(false);
        setIsError(true);
        setMessages(error.response?.data.errors.base);
      }
    }
  });

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        setIsOpen={setModalIsOpen}
        Trigger={
          <Button
            operationKlassToCheckPermission='Admin::Establishment::CompanyBranches::IncreaseFiservTefDatasetTableVersion'
            data-testid='increase_tef_table_version_button'
          >
            Incrementar tabela
          </Button>
        }
        useCancellableFooter
        showClose={false}
        title="Incrementar carga de tabela TEF"
        subtitle="Ao confirmar a ação você estará incrementando a versão da tabela desse estabelecimento, a ação não pode ser desfeita."
        titleClass='text-2xl'
        subtitleClassName="mt-2 text-sm"
        confirmButtonClassName="bg-blue-700"
        onConfirm={() => confirmFiscalDocument()}
      />
      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={isError}
          onClose={() => {
            queryClient.invalidateQueries({ queryKey: ['establishmentCompany', matrixBranchId] });
          }}
        />
      )}
    </>
  )
}
